<template>
  <div 
    class="cms-card" 
    :class="{ 
      'cms-card-clickable': clickable,
      'cms-card-elevated': elevated 
    }"
    @click="handleClick"
  >
    <div v-if="$slots.header || showHeader" class="cms-card-header">
      <slot name="header">
        <div class="cms-card-header-left">
          <slot name="status" />
        </div>
        <div class="cms-card-header-right">
          <slot name="actions" />
        </div>
      </slot>
    </div>
    
    <div class="cms-card-content">
      <slot />
    </div>
    
    <div v-if="$slots.footer" class="cms-card-footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  clickable?: boolean;
  elevated?: boolean;
  showHeader?: boolean;
}

withDefaults(defineProps<Props>(), {
  clickable: false,
  elevated: false,
  showHeader: true
});

const emit = defineEmits<{
  (e: 'click', event: MouseEvent): void;
}>();

const handleClick = (event: MouseEvent) => {
  emit('click', event);
};
</script>

<style lang="scss" scoped>
@import './cms-styles.scss';

.cms-card {
  background: $cms-background-white;
  border-radius: $cms-radius-lg;
  padding: $cms-spacing-lg;
  border: 1px solid $cms-border-color;
  transition: all $cms-transition-base;
  
  &-clickable {
    cursor: pointer;
    
    &:hover {
      transform: translateY(-4px);
      box-shadow: $cms-shadow-lg;
      border-color: darken($cms-border-color, 10%);
    }
  }
  
  &-elevated {
    box-shadow: $cms-shadow-sm;
  }
}

.cms-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: $cms-spacing-md;
  gap: $cms-spacing-md;
}

.cms-card-header-left,
.cms-card-header-right {
  display: flex;
  align-items: center;
  gap: $cms-spacing-sm;
}

.cms-card-content {
  display: flex;
  flex-direction: column;
  gap: $cms-spacing-md;
}

.cms-card-footer {
  margin-top: $cms-spacing-md;
  padding-top: $cms-spacing-md;
  border-top: 1px solid $cms-border-color;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: $cms-font-size-sm;
  color: $cms-text-secondary;
}
</style>

